import { HttpInterceptorFn } from '@angular/common/http';

export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  // For GET requests, append dynamic timestamp cache-buster parameter to bypass browser & CDN caches
  if (req.method === 'GET') {
    const separator = req.url.includes('?') ? '&' : '?';
    const noCacheReq = req.clone({
      url: `${req.url}${separator}_t=${Date.now()}`,
    });
    return next(noCacheReq);
  }

  return next(req);
};
